import axios from 'axios';

import { cleanDoubleSpaces } from "../../helpers/helper";
import { basicMsg, sweetMsg } from "../../helpers/admin/msgHelper";
import { axiosRequest, protectedReq } from '../../helpers/request/requestHelper';

const endpointUrl = process.env.REACT_APP_NEFRO_API_URL;

const GLOBAL_ERRORS = {
    // errores genéricos
    'axios-err': () => sweetMsg('error', 'Protocolo', 'Hubo un incidente en la petición'),
    'server-down': () => sweetMsg('error', 'Protocolo', 'No se recibió respuesta del servidor'),
    'server-err': () => sweetMsg('error', 'Protocolo', 'Hubo un incidente en el servidor'),
    'conn-err': () => basicMsg('Incidente en la conexión a la BD'),
    'exception': (context) => basicMsg(`Hubo un incidente al ${context}`),

    // listado de procotolos
    'no-results': () => basicMsg('La fecha no es válida'),

    // registro de protocolo
    'miss': () => basicMsg('Falta información de protocolo'),
    'no-content': () => sweetMsg('error', 'No registrado', 'No se envió correctamente la información'),
    'missing-info': () => sweetMsg('error', 'No registrado', 'No se envió correctamente la información'),
    'invalid-date': () => basicMsg('La fecha no es válida'),

    // actualización de protocolo
    'folder-not-exist': () => basicMsg('Carpeta de Google Drive no existe'),
    'not-updated': () => sweetMsg('info', 'Protocolo', 'El protocolo no fue actualizado'),
    
    // eliminación de protocolo
    'not-deleted': () => sweetMsg('warning', 'Protocolo', 'El protocolo no fue eliminado'),
};

export const getProtocols = async(setProtocols, setOriginalOrderString) => {
    try {
        const resp = await protectedReq('admin-protocol/list');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg !== 'no-results') {
                const runHandler = GLOBAL_ERRORS[body.msg] || (() => basicMsg('No se obtuvieron los protocolos'));
                runHandler('obtener los protocolos');
            }
            return;
        }
        setProtocols(body.resp);
        setOriginalOrderString(body.resp.map(p => p.protocolId).join(','));
    } catch (err) {
        sweetMsg('error', 'Protocolos', 'No se pudieron obtener los protocolos');
    };
};

// subir protocolo
export const uploadProtocol = async(
    { name, publicationDate, imageFile, documentFile },
    setOpenDialog, setOpen, setProtocols, clearForm
) => {
    setOpen(true); // mostrar Backdrop
    const title = cleanDoubleSpaces(name);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('publicationDate', publicationDate);
    formData.append('imageFile', imageFile);
    formData.append('documentFile', documentFile);

    const endpoint = `${endpointUrl}/admin-protocol/upload`;
    // token guardado
    const token = localStorage.getItem('token') || '';
    try {
        const config = { headers: { 'x-token': token } };
        const { data } = await axios.post(endpoint, formData, config);
        if (!data.status) {
            const runHandler = GLOBAL_ERRORS[data.msg] || (() => basicMsg('No se guardó el protocolo'));
            runHandler('publicar el protocolo');
            return;
        }

        // cerrar formulario
        setOpenDialog(e => ({ ...e, register: false }));
        // limpiar formulario
        clearForm();
        // agregar a lista de protocolos
        setProtocols(e => ([...e, { name: title, ...data.resp }]));
    } catch (err) {
        const message = err.response ? 'Incidente al publicar el protocolo' : 'No se pudo publicar el protocolo';
        sweetMsg('error', 'Protocolo', message);
    } finally {
        setOpen(false);
    };
};

// actualizar información de protocolo
export const updateProtocol = async(
    {
        protocolId, name, publicationDate,
        folderId, imageId, documentId,
        imageFile, documentFile
    },
    setOpenDialog, setOpen, setProtocols, clearRef
) => {
    try {
        console.log(imageFile)
        console.log(documentFile)
        setOpen(true); // mostrar Backdrop
        const title = cleanDoubleSpaces(name);
        const formData = new FormData();
        formData.append('protocolId', protocolId);
        formData.append('title', title);
        formData.append('publicationDate', publicationDate);
        formData.append('folderId', folderId);
        formData.append('imageId', imageId);
        formData.append('documentId', documentId);
        if (imageFile)
            formData.append('imageFile', imageFile);
        if (documentFile)
            formData.append('documentFile', documentFile);

        const data = await axiosRequest('/admin-protocol/update', 'POST', formData);
        console.log(data)
        if (!data.status) {
            const runHandler = GLOBAL_ERRORS[data.msg] || (() => basicMsg('No se actualizó el protocolo'));
            runHandler('actualizar el protocolo');
            return;
        }

        clearRef();
        // cerrar formulario
        setOpenDialog(e => ({ ...e, edit: false }));
        // actualizar protocolo en lista
        setProtocols(e => e.map(
            u => u.protocolId === protocolId ?
            { ...u, name: title, ...data.resp } : u
        ));
    } catch (err) {
        const message = err.response ? 'Incidente al actualizar el protocolo' : 'No se pudo actualizar el protocolo';
        sweetMsg('error', 'Protocolo', message);
    } finally {
        setOpen(false);
    };
};